import { Container, Heading, Text, Box, Separator } from "@chakra-ui/react";
import Head from "@/components/Head";

const title = "利用規約";

export default function Terms() {
  return (
    <>
      <Head title={title} robots={true} />

      <Container maxW="4xl" p={6}>
        <Box className="prose prose-sm max-w-none">
          <Heading as="h1" size="xl" mb={6}>
            OpenCourt アプリ利用規約
          </Heading>

          <Text mb={6}>
            本利用規約（以下「本規約」といいます。）は、「当社」が提供する1on1バスケットボールアプリ「OpenCourt」（以下「本アプリ」といいます。）の利用に関する条件を定めるものです。本アプリを自己の端末にダウンロード及びインストールして実行（以下、「利用」といいます。）する方（以下、「利用者」といいます。）は、本規約の内容を十分に理解し、同意の上で本アプリを利用するものとします。
          </Text>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第1条（総則）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              当社は、本アプリを自己の端末にダウンロード及びインストールして利用する利用者に対し、以下のとおり、「OpenCourt アプリ利用規約」を定めます。（Webアプリ版はダウンロード及びインストールの必要はない 2025年8月時点）
            </li>
            <li>
              本アプリのバージョンアップが行われた場合、バージョンアップ後の本アプリについても、本規約が適用されます。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第2条（規約同意）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              利用者は、本アプリを利用する前に本規約、別途定めるOpenCourt会員規約（以下「会員規約」といいます。）またはOpenCourt仮会員規約（以下「仮会員規約」といいます。）を確認し、同意の上で本アプリを利用するものとします。
            </li>
            <li>
                利用者が本アプリを利用した時点で、本規約、会員規約（会員登録手続を行わずに本アプリを利用した場合は、本規約及び仮会員規約）の内容に無条件で同意したものとみなします。
            </li>
            <li>
              当社は、本アプリ内で提供する個別の機能やサービスに関し、別途個別の規定や使用条件等（以下、「個別規定等」といいます。）を提示することがあります。個別規定等が本規約の内容と矛盾する場合には、個別規定等が優先して適用されます。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第3条（利用条件等）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              当社は利用者に対し、本規約に従うことを条件に、本アプリの非独占的かつ譲渡不能な利用を無償で許諾します。
            </li>
            <li>
              利用者は、自己の費用負担と責任において、本アプリを利用するために必要な端末及び通信手段を準備したうえで、本アプリを利用者の端末にダウンロードするものとします。
            </li>
            <li>
              本アプリのダウンロードをはじめ、本アプリの利用にかかる一切の通信料（バージョンアップにかかる通信料を含みます。）は、利用者の負担となります。
            </li>
            <li>
              利用者は、本アプリの利用にあたり、自己の責任において利用者の端末を適切に管理するものとし、第三者に利用させ、または貸与、譲渡、名義変更、売買、質入等してはならないものとします。
            </li>
            <li>
              OPEN COURTは、現在すべて無料でご利用いただけます。今後、料金体系に変更が生じる場合には、必ず事前に通知し、ご理解いただいたうえでご利用いただけるようにいたします。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第4条（禁止事項）
          </Heading>
          <Text mb={2}>
            利用者は、本アプリの利用にあたり、以下の行為を行ってはならないものとします。
          </Text>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              法令、公序良俗または本規約もしくは個別規定等その他当社との間の契約に違反する行為、またはそのおそれのある行為。
            </li>
            <li>
              当社または第三者の著作権、商標権、特許権、実用新案権、意匠権、肖像権、プライバシー権、名誉権、信用、その他の権利または利益を侵害する行為、またはそのおそれのある行為。
            </li>
            <li>
              本アプリの全部または一部を複製または改変すること、リバースエンジニアリング、逆コンパイル、逆アセンブル等解析行為を行うこと。
            </li>
            <li>
              本アプリの運営を妨害する行為、またはそのおそれのある行為。
            </li>
            <li>
              不正な目的での本アプリの利用。
            </li>
            <li>
              有害なコンピュータプログラム等を送信または書き込む行為、またはそれらを頒布する行為。
            </li>
            <li>
              本アプリのセキュリティ機能を妨害する行為。
            </li>
            <li>
              本アプリのバグや脆弱性を不正に利用する行為。
            </li>
            <li>
              OPEN COURT リワーズ（OPEN COURT参加や実績に応じて付与されるポイント、称号、バッジ、その他アプリ内アイテムおよび特典の総称）を不正に取得または利用する行為。
            </li>
            <li>
              年齢やスキルを偽る行為、または不正な方法でレーティングを操作する行為。
            </li>
            <li>
              他の利用者に対する誹謗中傷、嫌がらせ、その他不快な行為。
            </li>
            <li>
              反社会的勢力等に関連する行為、またはそれらを利する行為。
            </li>
            <li>
              当社の事前の承諾を得ることなく、本アプリを販売、賃貸、転載、公衆送信、利用許諾等すること。
            </li>
            <li>
              その他、当社が不適切と合理的に判断する行為。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第5条（知的財産権の帰属）
          </Heading>
          <Text mb={4}>
            本アプリ及び本アプリに関する著作権、商標権等の知的財産権その他一切の権利は、当社または正当な権限を有する第三者に帰属します。本規約は、明示的に定めがある場合を除き、利用者に対し、本アプリ及び本アプリに関するいかなる権利も移転するものではなく、かつ、利用・使用・実施等を許諾するものでもありません。
          </Text>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第6条（免責事項）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              当社は、本アプリの完全性、正確性、有用性、信頼性、安全性、最新性等について、いかなる保証も行うものではありません。
            </li>
            <li>
              当社は、本アプリの提供の中断、遅延、変更、終了、または本アプリの利用によって生じたいかなる損害についても、当社の故意または重過失による場合を除き、一切責任を負わないものとします。
            </li>
            <li>
              当社は、利用者が本アプリを通じて行う他の利用者との間の通信や交流について、一切関与せず、その結果について責任を負わないものとします。
            </li>
            <li>
              当社は、第三者のウェブサイトやサービスへのリンクを提供することがありますが、これらのウェブサイトやサービスの内容、利用規約、プライバシーポリシー等について一切責任を負わないものとします。
            </li>
            <li>
              本アプリは、現状有姿で提供されるものであり、当社は、特定の目的への適合性、商業的有用性、非侵害性等を含む、明示または黙示を問わず、いかなる保証も行わないものとします。
            </li>
            <li>
              当社は、当社の責に帰すべき事由なしに発生する利用者の端末の故障、OSのバージョンアップによる不具合、または第三者による不正利用等により利用者に損害が生じた場合でも、一切責任を負わないものとします。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第7条（規約の変更等）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              当社は、以下の各号のいずれかに該当する場合に、本規約を変更することがあります。その場合、当社は、本規約を変更する旨、変更後の本規約の内容および効力発生日を、本アプリ又は本プログラムに関連して当社が開設するウェブサイト等に表示することで利用者に周知します。第2号の場合には、その変更の周知は効力発生日から相当な期間前までに行います。変更後の本規約は、効力発生日から効力を生じるものとします。
            </li>
            <li>
              本規約の変更が、利用者の一般の利益に適合するとき。
            </li>
            <li>
              本規約の変更が、契約の目的に反するものではなく、かつ変更の必要性、変更後の内容の相当性、その他の変更に係る事情に照らして合理性があるとき。
            </li>
            <li>
              本規約の変更後は、変更後の内容のみ有効となります。
            </li>
            <li>
              利用者は、定期的に本規約の変更を確認する義務を負います。変更後に本アプリを利用した場合は、変更後の本規約に同意したものとみなされます。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第8条（本アプリの中断及び終了）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              当社は、次の各号に該当する場合に、本アプリの提供を中断又は終了させることがあります。
              <ul className="pl-6 mt-2 space-y-1">
                <li>本アプリの提供に必要な設備の保守・点検を行う場合又は障害が発生した場合。</li>
                <li>戦争、暴動、騒乱、地震、噴火、洪水、津波、火災、停電、労働争議、本アプリの提供に必要な機器またはプラットフォームの提供事業者による運営方針の変更その他の不可抗力により本アプリの提供が困難となった場合。</li>
                <li>その他当社が、本アプリの中断又は終了を判断した場合。</li>
                <li>その他、やむを得ない事情がある場合。</li>
              </ul>
            </li>
            <li>
              当社は、本アプリを中断又は終了するときには、当社のウェブサイト等で告知するものとします。ただし、本アプリの中断又は終了が緊急に必要となった場合、その他やむを得ない事情がある場合にはこの限りではありません。
            </li>
            <li>
                当社は、本アプリの中断または終了によって利用者に生じたいかなる損害についても、当社の故意または重過失による場合を除き、一切責任を負わないものとします。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第9条（準拠法、裁判管轄）
          </Heading>
          <Text mb={4}>
            本規約は、日本法に準拠し、日本法によって解釈されるものとします。本規約及び本アプリに関する一切の紛争は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
          </Text>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第10条（その他）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              本規約のいずれかの条項またはその一部が、法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効または執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。
            </li>
            <li>
              当社が利用者に対して行う通知は、本アプリ内の表示、電子メール、または当社のウェブサイトへの掲載等、当社が適当と判断する方法により行うものとします。
            </li>
            <li>
              利用者と当社との間の連絡は、当社が別途指定する方法により行うものとします。
            </li>
          </ul>

          <Separator my={8} />

          <Heading as="h1" size="xl" mb={6}>
            OpenCourt 会員規約
          </Heading>

          <Text mb={6}>
            本会員規約（以下「本規約」といいます。）は、株式会社OpenCourt（以下「当社」といいます。）が運営するOpenCourtプログラム（以下、「本プログラム」といいます。）の利用に関し、以下のとおり定めるものです。本規約は、本プログラムの会員（以下「会員」といいます。）に適用されます。
          </Text>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第1条（適用範囲）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              当社は本プログラムとして、OPEN COURT リワーズ（OPEN COURT参加や実績に応じて付与されるポイント、称号、バッジ、その他アプリ内アイテムおよび特典の総称）の提供、レーティングシステムの提供、対戦機会の提供、コミュニティ機能の提供等を行います。
            </li>
            <li>
              本規約は本プログラム並びに本プログラムを通じて付与または提供されたOPEN COURT リワーズ利用に適用されるものとします。
            </li>
            <li>
              本プログラムの利用には、OpenCourtアプリ利用規約への同意が必要です。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第2条（定義）
          </Heading>
          <Text mb={2}>本規約に定める主な用語の定義は、次の各号に掲げるとおりとします。</Text>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              OPEN COURT リワーズとは、当社が本プログラムの会員に対し、OPEN COURTへの参加や実績に応じて付与するポイント、称号、バッジ、その他のアプリ内アイテムおよび特典の総称です。
            </li>
            <li>
              「基本リワーズ」とは、OpenCourtのうち本規約の規定に基づく有効期限のポイントをいいます。
            </li>
            <li>
              「期間限定リワーズ」とは、OpenCourtリワーズのうち本規約の規定と異なる有効期限を当社および加盟店が別途定めたリワーズをいいます。
            </li>
            <li>
              「本リワーズ」とは、基本リワーズと期間限定リワーズの両方をいいます。
            </li>
            <li>
              「特典」とは、会員に向けて本プログラムとして提供される称号、バッジ、デジタルアイテム、イベントへの参加権、割引クーポン、その他当社が定めるサービス等をいいます。
            </li>
            <li>
              「会員」とは、本規約及びOpenCourtアプリ利用規約に同意の上、当社が定める所定の手続きを経て会員登録を行った個人をいいます。なお、会員は満18歳以上の方に限ります。
            </li>
            <li>
              「本アプリ」とは、本プログラムを利用するために当社が提供するアプリケーションをいいます。
            </li>
            <li>
              「会員情報」とは、入会希望者が会員登録時に当社に届け出た事項、入会後に本プログラムに付帯するサービスの申込または利用のために会員が当社に届け出た事項、及び入会後に会員から変更の届出を受ける等、会員による本プログラムの利用に伴って当社が知り得た会員に関する情報をいいます。
            </li>
            <li>
              「会員証」とは、本プログラムを利用するにあたって会員本人を特定するために、会員が本アプリを通じて発行を受けた情報をいいます。
            </li>
            <li>
              「レーティング」とは、会員のゲームスキルを評価するために当社が定める基準に基づいて算出される数値。
            </li>
            <li>
              「称号」とは、ゲームスキル、連続勝利、特定イベントへの参加などの条件に応じて当社が付与する名誉。
            </li>
            <li>
              「バッジ」とは、ゲームスキルや特定のアクションの達成に応じて当社が付与するデジタルアイテム。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第3条（会員登録）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              本プログラムを利用するためには、次項に定める入会手続が必要となります。
            </li>
            <li>
              入会希望者は、本規約及びOpenCourtアプリ利用規約に同意の上、当社が定める所定の手続きを行い、本アプリを用いて会員登録するものとし、当社が入会を承認し、当社のシステムに会員情報が登録された時点で、入会が完了するものとします。入会が完了した場合、当社は当該会員に対し本アプリを通じて、会員証を発行します。
            </li>
            <li>
              当社は、入会希望者が次のいずれかに該当する場合、当該入会希望者による入会を承認しないことがあります。
              <ul className="pl-6 mt-2 space-y-1">
                <li>会員登録時の申告内容に虚偽、誤記または記入漏れがあるとき。</li>
                <li>本規約、OpenCourtアプリ利用規約その他当社との間の契約に定める条件に違反するおそれがあると合理的に認められるとき。</li>
                <li>過去に本規約、OpenCourtアプリ利用規約その他当社との間の契約に定める条件に違反したことがあるとき。</li>
              </ul>
            </li>
            <li>
              【未成年者の利用について】
              <ul className="pl-6 mt-2 space-y-1">
                <li>本サービスは、満18歳未満の方がご利用になる場合、必ず保護者の同意を得たうえでご登録・ご利用ください。</li>
                <li>満18歳未満の方が保護者の承認を得ずに利用規約へ同意した場合、登録は無効となる場合があります。その際、入会手続きの取り消しや、利用に伴う責任について当サービスでは責任を負いかねますので、あらかじめご了承ください。</li>
              </ul>
            </li>
            <li>
              その他、当社が会員として不適格と判断した場合。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第4条（会員証の管理）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              会員証は会員本人のみが使用することができるものとします。
            </li>
            <li>
              会員は、本アプリのログインパスワードとして他のサービスと同一のパスワードの使いまわしをせず、また、ログインパスワードを定期的に変更するなど、責任をもって会員証を管理するものとし、会員証を第三者に使用させることや、貸与、譲渡、名義変更、売買、質入等その他いかなる処分もしてはならないものとします。
            </li>
            <li>
              当社は、正当な会員証が使用された手続・操作等については、会員本人が行ったものとみなすものとします。第三者が会員証を使用したことによる損害の負担は会員が負うものとし、当該損害が当社の故意もしくは重過失または当社からの会員情報の漏洩により生じた場合を除き、当社は一切の責任を負わないものとします。また、当該損害が当社の過失（重過失を除く。）により生じた場合、当社が賠償する損害は、通常かつ直接の損害に限るものとし、当社は間接損害、特別損害、付随的損害、派生的損害、逸失利益、使用機会の喪失による損害についての責任は負わないものとします。
            </li>
            <li>
              会員は、会員証その他会員情報が漏洩し、会員証が第三者に使用されていることを知った場合、または本アプリをインストールしている機器の盗難・紛失などが発生した場合、当社に対し速やかに利用停止を申請するものとし、漏洩・盗難・紛失などにより会員または第三者に損害が生じても、当該損害が当社の故意もしくは重過失または当社からの会員情報の漏洩により生じた場合を除き、当社は一切の責任を負いません。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第5条（OpenCourtリワーズの付与）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              当社は、会員が本アプリにおいて当社の指定する方法で対戦を行う、イベントに参加する、特定のアクションを達成する（自己成長ミッションの達成、フェアプレイ、ミニトーナメントでの勝利、ランクアップチャレンジへの参加、特定イベントでの投票など）等、リワーズ付与の対象となるアクション（以下、「対象アクション」といいます。）を行ったときその他当社が相当と認めた場合に、当社の定める付与条件に従い、当該会員に対してOpenCourtリワーズを付与するものとします。
            </li>
            <li>
              OpenCourtリワーズ付与の対象となる対象アクション、OpenCourtリワーズ付与の時期、OpenCourtリワーズ数、OpenCourtリワーズの有効期間、その他OpenCourtリワーズ付与の条件は、当社の裁量で定めるものとし、当社が定める所定の方法にて会員に告知するものとします。
            </li>
            <li>
              OpenCourtリワーズは、対象アクションが行われてから、当社が定める一定の期間を経た後に付与されるものとします。この期間内に、当社が対象アクションの削除、取消などがあったことを確認した場合、OpenCourtリワーズは付与されないものとします。
            </li>
            <li>
              対象アクションについてOpenCourtリワーズを付与するか否か、付与するOpenCourtリワーズ数、その他OpenCourtリワーズ付与に関する最終的な判断は、当社が行うものとし、会員はこれに異議を唱えないものとします。
            </li>
            <li>
              当社または加盟店の企画により、OpenCourtリワーズ付与率の変更やお買上げを伴わないOpenCourtリワーズ付与を行う場合があります。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第6条（OpenCourtリワーズの利用）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              会員は、付与されたOpenCourtリワーズを、当社が指定する方法で本アプリ内のサービス、特典等（デジタルアイテム、限定コンテンツへのアクセス権、イベント参加権、グッズとの交換、その他当社が定めるものを含みますがこれらに限られません。以下「特典等」といいます。）と交換することができます。当社は、交換できる特典等を随時設定し、特典等の内容、交換に必要なOpenCourtリワーズ数、交換方法等については当社が定める方法にて会員に告知するものとします。
            </li>
            <li>
              特典等の種類、内容、交換に必要なOpenCourtリワーズ数、その他OpenCourtリワーズ交換の条件は当社が定めるものとし、当社はこれらを任意に新規設定、変更または終了させることができます。
            </li>
            <li>
              会員は、OpenCourtリワーズを現金、または当社の指定以外のサービスや商品と交換することはできません。
            </li>
            <li>
              会員が決済においてOpenCourtリワーズを利用し、その後、当該取引がキャンセルとなった場合、当該決済に利用されたOpenCourtリワーズが返還され、現金による返還は行われません。なお、OpenCourtリワーズの利用が取り消される場合であっても、取消時点でOpenCourtリワーズの有効期間が過ぎた場合やその他当社所定の利用条件により、利用することができない場合があるものとします。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第7条（OpenCourtリワーズの有効期限）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              OpenCourtリワーズには有効期限があるものとし、有効期限はOpenCourtリワーズの種類や付与条件等によって当社が別途定めるものとします。有効期限は、本アプリ内または当社のウェブサイト等で告知します。
            </li>
            <li>
              有効期限を過ぎたOpenCourtリワーズは自動的に失効し、利用することができなくなります。失効したOpenCourtリワーズについて、当社は一切補償を行いません。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第8条（OpenCourtリワーズの取消）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              当社がOpenCourtリワーズを付与した後に、対象アクションについて削除、取消その他当社がOpenCourtリワーズの付与を取り消すことが適当と判断する事由があった場合、当社は、当該対象アクションにより付与されたOpenCourtポイントを取り消すことができます。
            </li>
            <li>
              当社は会員が下記のいずれかに該当すると判断した場合、会員に事前に通知することなく、会員が保有するOpenCourtリワーズの一部または全部を取り消すことができます。
              <ul className="pl-6 mt-2 space-y-1">
                <li>会員が本規約・OpenCourtアプリ利用規約・その他当社が定める規約等に違反した場合。</li>
                <li>不正な行為または不適切な行為によりOpenCourtリワーズを取得または利用した場合。</li>
                <li>その他、当社がOpenCourtリワーズの取消しが適当と判断した場合。</li>
              </ul>
            </li>
            <li>
              当社は、取り消されたOpenCourtリワーズについて、一切補償を行う義務を負いません。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第9条（特典）
          </Heading>
          <Text mb={4}>
            当社は、会員に対し、OpenCourtリワーズの交換または当社の定める条件に従い、各種特典を提供します。特典の内容、提供方法、利用条件等は当社が別途定めるものとし、本アプリ内または当社のウェブサイト等で告知します。当社は、特典の内容をいつでも変更、停止、または終了することができるものとし、会員はこれに異議を唱えないものとします。
          </Text>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第10条（会員資格の喪失）
          </Heading>
          <Text mb={2}>
            会員が以下のいずれかに該当する場合、会員資格を喪失するとともに、保有するOpenCourtリワーズの全てが失効するものとします。また、当社は会員が以下のいずれかに該当する可能性があることを認識した場合、認識した時点で当該会員への本プログラムの全部または一部の提供を停止することがあります。
          </Text>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              本規約、OpenCourtアプリ利用規約その他当社との間の契約に定める条件に違反し、当社が会員として不適格であると判断した場合。
            </li>
            <li>
              第3条第3項各号のいずれかに該当することが判明した場合。
            </li>
            <li>
              不正利用、本プログラムの利用上必要のない複数回の会員登録、その他正常でない方法でOpenCourtリワーズが付与され又はOpenCourtリワーズおよび特典が利用された場合。
            </li>
            <li>
              当社からの連絡が取れなくなった場合。
            </li>
            <li>
              本リワーズの付与又は利用を伴うポイント残高の最終変動日から5年間本プログラムのご利用がない場合。
            </li>
            <li>
              会員が死亡した場合。
            </li>
            <li>
              その他、当社が会員資格の喪失が適当と判断した場合。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第11条（会員情報の取り扱い）
          </Heading>
          <Text mb={4}>
            当社は、別途定めるプライバシーポリシーに従い、会員の個人情報を適切に管理および利用します。会員は、本プログラムを利用する前にプライバシーポリシーの内容を再度確認し、同意するものとします。
          </Text>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第12条（本プログラムの中断及び終了）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              当社は、次の各号に該当する場合に、本プログラムを中断又は終了させることがあります。
              <ul className="pl-6 mt-2 space-y-1">
                <li>本プログラムの提供に必要な設備の保守・点検を行う場合又は障害が発生した場合。</li>
                <li>戦争、暴動、騒乱、地震、噴火、洪水、津波、火災、停電、労働争議、本プログラムの提供に必要な機器またはプラットフォームの提供事業者による運営方針の変更その他の不可抗力により本プログラムの提供が困難となった場合。</li>
                <li>その他当社が、本プログラムの中断又は終了を判断した場合。</li>
                <li>その他、やむを得ない事情がある場合。</li>
              </ul>
            </li>
            <li>
              当社は、本プログラムを中断又は終了するときには、当社のウェブサイト等で告知するものとします。ただし、本プログラムの中断又は終了が緊急に必要となった場合、その他やむを得ない事情がある場合にはこの限りではありません。
            </li>
            <li>
              当社は、本プログラムの中断または終了によって会員に生じたいかなる損害についても、当社の故意または重過失による場合を除き、一切責任を負わないものとします。
            </li>
            <li>
              OpenCourtリワーズの清算等については、当社の定める方法に従うものとします。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第13条（準拠法、裁判管轄）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              本規約は、日本法に準拠し、日本法によって解釈されるものとします。
            </li>
            <li>
              本規約及び本プログラムに関する一切の紛争は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
            </li>
          </ul>

          <Heading as="h2" size="lg" mt={8} mb={4}>
            第14条（その他）
          </Heading>
          <ul className="pl-6 mb-4 space-y-2">
            <li>
              会員は、登録した会員情報に変更があった場合、速やかに当社所定の方法により変更の手続きを行うものとします。会員が前項の変更手続を行わず、当社及び加盟店からの連絡または通知が届かなかったことにより生じた損害について、当社及び加盟店は一切責任を負いません。
            </li>
            <li>
              本規約のいずれかの条項またはその一部が、法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効または執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。
            </li>
            <li>
              当社が会員に対して行う通知は、本アプリ内の表示、電子メール、または当社のウェブサイトへの掲載等、当社が適当と判断する方法により行うものとします。
            </li>
            <li>
              会員と当社との間の連絡は、当社が別途指定する方法により行うものとします。
            </li>
          </ul>

          <Text mt={8} fontSize="sm" color="gray.500">
            2025年8月20日制定
          </Text>
          <Text fontSize="sm" color="gray.500">
            最終更新：2025年8月20日
          </Text>
        </Box>
      </Container>
    </>
  );
}
